const endOfNzDay = (y, m, d) => Date.UTC(y, m - 1, d, 10, 59, 59);

export const CHRISTMAS_CUTOFFS = [
  { key: "custom", label: "Custom prints", day: "Fri 27 Nov", until: endOfNzDay(2026, 11, 27) },
  { key: "courier", label: "Ready-made, courier delivery", day: "Fri 11 Dec", until: endOfNzDay(2026, 12, 11) },
  { key: "pickup", label: "Ready-made, pickup in Upper Hutt", day: "Fri 18 Dec", until: endOfNzDay(2026, 12, 18) },
];

export const CHRISTMAS_END = Date.UTC(2026, 11, 24, 11);

export const cutoffFor = (key) => CHRISTMAS_CUTOFFS.find((c) => c.key === key);
